import React from "react";
import Clients from "../Clients";
import Client from "./Client"
import Address from "../../../_components/Address";
import Create from '../../../components/pages/clients/create'
import Edit from '../../../components/pages/clients/edit'
const onChange = data => {
  console.debug(data)
}

export const paths = [
  {
    path: "/clients",
    component: Clients,
  },
  {
    path: "/clients/address",
    component: () => <div>
      <Address onChange={onChange} />
    </div>,
  },
  {
    path: "/clients/create",
    component: Create,
  },
  {
    path: "/clients/:id",
    component: Edit,
  },
];

export const ClientsRouters = {
  icon: "users",
  testId: "",
  label: "Clientes",
  tree: [
    {
      icon: "plus",
      testId: "",
      path: "/clients/create",
      label: "Cadastrar",
    },
    {
      icon: "list-ul",
      testId: "",
      path: "/clients",
      label: "Listar",
    },
  ],
};


// WEBPACK FOOTER //
// ./src/views/AppViews/Clients/routers.js